/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FundsRaisedResponseDto } from '../../models/funds-raised-response-dto';

export interface AdminInsightsControllerGetFundsRaisedV1$Params {

/**
 * Time period for aggregation (default: monthly)
 */
  period?: 'weekly' | 'monthly' | 'yearly';
}

export function adminInsightsControllerGetFundsRaisedV1(http: HttpClient, rootUrl: string, params?: AdminInsightsControllerGetFundsRaisedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FundsRaisedResponseDto>> {
  const rb = new RequestBuilder(rootUrl, adminInsightsControllerGetFundsRaisedV1.PATH, 'get');
  if (params) {
    rb.query('period', params.period, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FundsRaisedResponseDto>;
    })
  );
}

adminInsightsControllerGetFundsRaisedV1.PATH = '/v1/admin/insights/funds-raised';
